import type { ApiClient } from './client.js';
import type { RegisterRepoBody, RepoEntry, RepoStatsResponse } from './types.js';

export async function listRepos(api: ApiClient): Promise<readonly RepoEntry[]> {
  const res = await api.request<{ repos: RepoEntry[] }>('/api/repos');
  return res.repos;
}

export async function registerRepo(api: ApiClient, body: RegisterRepoBody): Promise<RepoEntry> {
  const res = await api.request<{ repo: RepoEntry }>('/api/repos', {
    method: 'POST',
    body: JSON.stringify(body),
  });
  return res.repo;
}

export async function reindexRepo(api: ApiClient, slug: string): Promise<string> {
  const res = await api.request<{ jobId: string }>(
    `/api/repos/${encodeURIComponent(slug)}/reindex`,
    {
      method: 'POST',
      body: JSON.stringify({}),
    },
  );
  return res.jobId;
}

export async function getRepoStats(api: ApiClient, slug: string): Promise<RepoStatsResponse> {
  return api.request<RepoStatsResponse>(`/api/repos/${encodeURIComponent(slug)}/stats`);
}
